import { apiAdminInstance } from "../Api/ApiInstance";

export const ListFilterTransmition = async () => {
  return await apiAdminInstance.get(
    "api/official-site/transmition/filter"
  );
};
